export default __webpack_public_path__ + "static/media/src_jquery_mobile_6.241fda3b.jpg";